import { HandlingUnitMaterialSearchCriteria } from '../../../models';

export class HandlingUnitMaterials {
  public static readonly type = '[HandlingUnitMaterials] Load Handling Units';
  constructor(
    public payload: {
      deliveryNoteNumber: string;
      handlingUnitNumber: string;
      searchCriteria: HandlingUnitMaterialSearchCriteria;
    },
  ) {}
}

export class HandlingUnitMaterialsInitialState {
  public static readonly type = '[HandlingUnitMaterials] Set Initial State';
}
